import {AfterViewInit, Component, Inject, OnChanges, OnInit,} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup,} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '@services/auth.service';
import {LoaderService} from '@services/loader.service';
import {DOCUMENT} from '@angular/common';
import {environment} from '@environments/environment';

@Component({
    selector: 'app-login',
    template: `
        <ng-content></ng-content>`,
    standalone: false
})
export class LoginPageComponent implements OnInit, AfterViewInit, OnChanges {
    constructor(
        private fb: UntypedFormBuilder,
        @Inject(DOCUMENT) private document: Document,
        private authService: AuthService,
        private loaderService: LoaderService,
        private cookieService: CookieService
    ) {
    }

    public loginForm!: UntypedFormGroup;
    public error: boolean = false;

    login(): void {
    }

    goToLoginUrl(): void {
        const buildName = this.cookieService.get('buildName');

        if (!environment.login.retrieveBuild) {
            this.document.location.href = `${environment.login.externaloginPage}/login`;
        }

        if (this.cookieService.check('buildName')) {
            this.document.location.href = `${environment.login.externaloginPage}/${buildName}`;
        }

        this.document.location.href = `${environment.login.externaloginPage}/login`;
    }

    ngOnInit(): void {
        this.goToLoginUrl();
    }

    ngAfterViewInit(): void {
        this.loaderService.hide();
    }

    ngOnChanges(): void {
        this.loaderService.hide();
    }
}
